import { render, staticRenderFns } from "./EditProductType.vue?vue&type=template&id=6d017f42&scoped=true&"
import script from "./EditProductType.vue?vue&type=script&lang=js&"
export * from "./EditProductType.vue?vue&type=script&lang=js&"
import style0 from "./EditProductType.vue?vue&type=style&index=0&id=6d017f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d017f42",
  null
  
)

export default component.exports